import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { NotificationModule } from '@features/notification/notification.module';
import { SharedModule } from '@features/shared/shared.module';
import { StateModule } from '@features/state/state.module';
import { IMCC_HTTP_INTERCEPTORS } from 'app/imcc-http-interceptors';
import { OrderProgressService } from './order-progress.service';
import { OrdersService } from './order.service';

@NgModule({
  declarations: [],
  providers: [...IMCC_HTTP_INTERCEPTORS, OrdersService, OrderProgressService],
  imports: [StateModule, SharedModule, HttpClientModule, NotificationModule],
  exports: [],
})
export class OrdersServicesModule {}
